import s, { useEffect as i } from "react";
import m from "hoist-non-react-statics";
let n = {};
const p = (a = "The $name component is deprecated.") => (e) => {
  const t = (r) => {
    const o = e.displayName || e.name;
    if (!n[o]) {
      const c = a.replace("$name", o);
      console.warn(c), n[o] = !0;
    }
    return /* @__PURE__ */ s.createElement(e, { ...r });
  };
  return t.displayName = e.displayName || e.name, m(t, e), t;
}, u = (a, e = "The $name component is deprecated.") => {
  i(() => {
    n[a] || (console.warn(e.replace("$name", a)), n[a] = !0);
  }, [a, e]);
};
export {
  p as d,
  u
};
